import { Button, Grid, Paper, Typography, IconButton, TextField, Box } from '@mui/material'
import React from 'react'
import Header from '../../Header';
import i18next from 'i18next';
import { Trans } from 'react-i18next';
import { useState } from 'react';
import { useNotify } from '../../Notify/NotifyProvider'
import request from '../../../helpers/myAxios'
import { useEffect } from 'react';
import { Gate } from '../../../types/Gate';
import RefreshIcon from '@mui/icons-material/Refresh';
import ClearIcon from '@mui/icons-material/Clear';
import { Event } from '../../../types/Event';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';
import moment from 'moment';
import { DatePicker } from '@mui/x-date-pickers';

const maxViewWidth = 1200;
var doit: any;

interface ManageGateViewProps {
}

function ManageGateView(props: ManageGateViewProps) {
    const notify = useNotify();
    //const confirm = useConfirm();

    const [events, setEvents] = useState<Event[]>([]);
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);

    const handleUpdate = () => {

        let query = "";
        if (startDate)
            query = "?from=" + startDate.toString();

        if (endDate)
            query += "&to=" + endDate.toString();

        request().get('/event' + query).then((res) => {
            setEvents(res.data);
        }).catch((err) => {
            if (err.response && err.response.status === 404)
                setEvents([]);
            else
                notify.error(i18next.t('HistoryView.msgNoEventFound'));
        });
    }

    const handleClear = () => {
        setStartDate(null);
        setEndDate(null);
    }

    //Force recalculate table size on first render
    useEffect(() => {
        handleUpdate();
    }, [props]);

    const prettyDate = (event: Event): Event => {
        let newEvent = JSON.parse(JSON.stringify(event));
        if (newEvent.when)
            newEvent.when = moment(newEvent.when).format('Y-MM-DD HH:mm:ss.SSS');

        return newEvent;
    }

    let gateWidgets = events.map(event => {
        return <Grid item sm={12}>
            <Paper sx={{ width: maxViewWidth }}>
                <div>
                    <JSONPretty data={prettyDate(event)}></JSONPretty>
                </div>
            </Paper>
        </Grid>;
    });

    return (
        <div style={{ display: 'flex', height: '100%', width: '100%', flexFlow: 'column' }}>
            <Header title={i18next.t("HistoryView.title")} >
            </Header>
            <Box sx={{ px: 2, pt: 2, pb: 1, width: '100%' }}>
                <Grid container sx={{ pt: 1 }}>
                    <Grid item xs={2}>
                        <DatePicker openTo="year" views={['year', 'month', 'day']} label={i18next.t('MultipleDateRangePicker.from')}
                            value={startDate} onChange={(newValue: any) => setStartDate(newValue)} inputFormat='yyyy-MM-dd'
                            renderInput={(params: any) => <TextField  {...params} helperText={null} size='small' sx={{ pr: 1 }} />}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <DatePicker disabled={startDate === null}
                            openTo="year" views={['year', 'month', 'day']} label={i18next.t('MultipleDateRangePicker.to')}
                            value={endDate} onChange={(newValue: any) => setEndDate(newValue)} inputFormat='yyyy-MM-dd'
                            renderInput={(params: any) => <TextField {...params} helperText={null} size='small' sx={{ pr: 1 }} />}
                        />
                    </Grid>
                    <Grid item sm={1}>
                        <IconButton aria-label="Refresh" size="small" onClick={handleClear}>
                            <ClearIcon fontSize="inherit" />
                        </IconButton>
                        <IconButton aria-label="Refresh" size="small" onClick={handleUpdate}>
                            <RefreshIcon fontSize="inherit" />
                        </IconButton>
                    </Grid>
                </Grid>
                <div style={{ width: '100%' }}>
                    <div style={{ margin: 'auto', width: maxViewWidth, height: '100%' }}>
                        {gateWidgets}
                    </div>
                </div>
            </Box>
        </div>
    )
}

export default ManageGateView

